import axios from "axios";
import { UserState } from "@/store/modules/user/types";
import { getToken } from "@/utils/auth";
import "./interceptor";

export interface LoginData {
  username: string;
  password: string;
  code:string;
  phonenumber:string;
  uuid:string;
}

export interface LoginRes {
  code: number;
  msg: "";
  token: string;
}
export interface userRes {
  code: number;
  msg: "";
  permissions: any;
  projectList: any;
  roles: any;
  user: any;
}
const HOST = process.env.VUE_APP_API;

export function login(data: LoginData) {
  return axios.post<LoginRes>(HOST + "/login", data);
}
export function getRouters() {
  return axios.get<LoginRes>(HOST + "/getRouters");
}

export function logout() {
  return axios.post<LoginRes>(HOST + "/logout");
}

export function getUserInfo() {
  return axios.get<userRes>(HOST + "/getInfo");
}

export function setSessionLoginSchooId(id: string) {
  return axios.get<userRes>(HOST + "/setSessionLoginSchooId?loginSchoolId=" + id);
}
export function quitSessionLoginSchooId() {
  return axios.get<userRes>(HOST + "/quitSessionLoginSchooId");
}
export function getCodeImg() {
  return axios.get<userRes>(HOST + "/captchaImage");
}
export function getLoginProject() {
  return axios.get<userRes>(HOST + "/getLoginProject");
}
export function getUserProfile() {
  return axios.get<userRes>(HOST + "/system/user/profile/profile");
}
export function updateUserProfile(data: any) {
  return axios.post<userRes>(HOST + "/system/user/profile/updateProfile", data);
}
export function uploadUserAvatar(data: any) {
  return axios.post<userRes>(HOST + "/system/user/profile/avatar", data);
}

// 旧版密码
// export function updateUserPwd(oldPassword: string, newPassword: string) {
//   return axios.post<userRes>(
//     HOST + "/system/user/profile/updatePwd?oldPassword=" + oldPassword + "&newPassword=" + newPassword
//   );
// }

// 基于base64的密码变更
export function updateUserPwd(data:any) {
  return axios.post<userRes>(HOST + "/system/user/profile/updatePwd",data);
}
